import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapArray'
})
export class MapArrayPipe implements PipeTransform {
  transform(value: string[] | undefined | null, length: number = 3, tooltip: boolean = false): string {
    if (!value || value.length === 0) {
      return '--';
    }

    if (tooltip) {
      return value.join(', ');
    }

    const names = value.slice(0, length).join(', ');
    if (value.length > length) {
      return names + '...';
    }

    return names;
  }
}
